import { render, staticRenderFns } from "./Flashcards.vue?vue&type=template&id=f81c21e4&"
import script from "./Flashcards.vue?vue&type=script&lang=js&"
export * from "./Flashcards.vue?vue&type=script&lang=js&"
import style0 from "./Flashcards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Flashcards.vue"
export default component.exports